<template>
  <div class="app">
    <AppHeader fixed id="header">
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="/logo.png" width="auto" height="50" alt="CPSP" />
        <img class="navbar-brand-minimized" src="/logo.png" width="30" height="auto" alt="CPSP" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="ml-0 pt-2">
        <h5><strong>斯道拉恩索</strong></h5>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mr-1">
        <!-- 您好！ -->

        <strong class="d-md-down-none">{{ user.user_name }}</strong>
        <DefaultHeaderDropdownAccnt :userName="user.user_name" class="d-lg-none" mobile />
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" ref="sidebarRef" />
    </AppHeader>
    <div class="app-body" :class="theme">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>

      <main class="main">
        <!-- <Breadcrumb :list="list" /> -->
        <div style="display: table; width: 100%">
          <div style="display: table-row">
            <div style="display: table-cell">
              <Breadcrumb :list="list" class="form-inline" style="margin-bottom: 0 i !important"></Breadcrumb>
            </div>
            <div style="
                display: table-cell;
                background-color: white;
                border-bottom: 1px solid #dee2e6;
              ">
              <div style="text-align: right">
                <strong style="
                    /* height: 20px; */
                    /* line-height: 20px; */
                    margin: 0px 0px 0px 5px;
                    /* color: #939393; */
                  "><span v-if="is_production">CPSP &nbsp;</span>
                  Version
                  {{ plantSetting.version }}</strong>
              </div>
            </div>
            <div style="
                display: table-cell;
                background-color: white;
                border-bottom: 1px solid #dee2e6;
                width: 96px;
              ">
              <div style="text-align: right; padding: 0 4px">
                <el-badge :value="messageDataCount" :max="10" class="mr-4">
                  <el-button class="iconfont icon-notice" size="mini" @click="toMessage"></el-button>
                </el-badge>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </main>
      <!-- 右侧选项 -->
      <AppAside fixed ref="rightSideBar">
        <RightMenuConstainer ref="rightMenu" @changeTheme="changeTheme" />
      </AppAside>
    </div>
    <TheFooter id="footer" style="
        margin-right: 0px !important;
        background-color: white;
        z-index: 999;
        height: 0px;
      ">
      <!-- <div
        style="width:300px;margin:0 auto; padding:10px 0;"
        v-if="is_production"
      >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13028302000150"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img src="../../public/img/police.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            冀公网安备 13028302000150号
          </p></a
        >
      </div> -->
      <div style="
          display: table;
          background-color: white;
          width: calc(100% - 200px);
        ">
        <div style="display: table-row">
          <div style="display: table-cell">
            <strong class="d-md-down-none" style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              ">
              Copyright © {{ plantSetting.copy_right }}
            </strong>
            <strong style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              " v-if="is_production">&nbsp; Stora Enso &nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #939393">冀ICP备06025035号-2</a></strong>
            <div style="margin: 0; padding: 0; height: 20px" v-if="is_production" class="ml-2">
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13028302000150"
                style="
                  display: inline-block;
                  text-decoration: none;
                  height: 20px;
                  line-height: 20px;
                "><img src="../../public/img/police.png" style="float: left" />
                <p style="
                    float: left;
                    height: 20px;
                    line-height: 20px;
                    margin: 0px 0px 0px 5px;
                    color: #939393;
                  ">
                  冀公网安备 13028302000150号
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- <strong style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;" v-if="is_production">&nbsp; Stora Enso &nbsp;&nbsp;&nbsp;&nbsp;</strong> -->
    </TheFooter>
    <el-dialog title="待办事项" :visible.sync="dialogTableVisible">
      <el-table :data="messageData" height="500" style="font-size: 14px">
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="pl-2">
              <el-form-item label="内容">
                <span>{{ props.row.context }}</span>
              </el-form-item>
            </el-form>
          </template>
</el-table-column> -->
        <el-table-column property="num" label="序号" width="80"></el-table-column>
        <el-table-column property="context" label="内容"></el-table-column>
        <el-table-column property="create_at" label="时间" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from '../shared/event_bus';

import nav from '@/_nav';
import {
  Aside as AppAside,
  Header as AppHeader,
  Sidebar as AppSidebar,
  AsideToggler,
  Breadcrumb,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarToggler,
  Footer as TheFooter,
} from '@coreui/vue';
import jwtDecode from 'jwt-decode';
// -- import * as _ from "lodash-es"
import * as CustTableBindUserController from '../controllers/base/CustTableBindUserController';
import * as NotifyTemplateManageController from '../controllers/system/NotifyTemplateManageController';
import * as SystemSettingController from '../controllers/system/SystemSettingController';
import * as UserManageController from '../controllers/system/UserManageController';
import * as api from '../shared/api';
import apiPath from '../shared/apiPath';
import * as localStorageMgr from '../shared/localStorageMgr';
import plantSetting from '../shared/plant_setting';
import * as sessionStorageMgr from '../shared/sessionStorageMgr';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import RightMenuConstainer from './RightMenuConstainer';
import * as commonController from '../controllers/commonController';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    RightMenuConstainer,
  },
  data() {
    return {
      dialogTableVisible: false,
      is_production: true,
      logo: '',
      nav: nav.items,
      imageUrl: '/img/avatars/default_tx.jpg',
      plantSetting: plantSetting,
      user: {
        user_name: '',
        is_Include_All: false,
      },
      theme: 'secpNavStyle3 secp-content',
      lang_data: {},
      locale: 'zh-CN',
      messageData: [],
      messageDataCount: 0,
      time_count: 0,
    };
  },

  async created() {
    let this_ = this;
    if (localStorage.getItem('locale')) {
      this.locale = localStorage.getItem('locale');
    }
    await this.$loadLanguageAsync(this.locale, this.$i18n);
    ///判定是否存在平台配置信息
    if (
      this.ls.get('access_token') &&
      !sessionStorageMgr.get(sessionStorageMgr.data.cpsp_store)
    ) {
      ///获取公共信息保存到localStorage,code:"_cpsp_Setting"
      // let plant_setting = await api.query_async({
      //   url: apiPath.common.get_setting,
      //   parameters: null,
      //   method: "get",
      // });
      // if (plant_setting) {
      //   this.$store.commit("init_biz_data", {
      //     content_path: "biz_data",
      //     content_type: "plantSetting",
      //     data: plant_setting[0].result.data,
      //   });
      // }
      ///获取用户信息并初始化store
      // let user_idx = JSON.parse(atob(this.ls.get("access_token").split(".")[1])).data.idx;
      // let user_info_result = await api.query_async({
      //   url: apiPath.user.get_userinfo,
      //   parameters: user_idx,
      //   method: "get",
      // });
      // if (user_info_result && user_info_result[0] && user_info_result[0].result) {
      //   let _user_info = user_info_result[0].result.data.user;
      //   this.$store.commit("init_biz_data", {
      //     content_path: "biz_data",
      //     content_type: "userInfo",
      //     data: _user_info,
      //   });
      // }
    }

    ///显示用户信息
    // if (this.$store.state.biz_data) {
    //   if (this.$store.state.biz_data.userInfo) {
    //     let _user = _.cloneDeep(this.$store.state.biz_data.userInfo);
    //     this.user.user_name = _user.realname;
    //   }
    // }

    const loading = this.$loading({
      lock: true,
      text: this.$t('notify.loading'),
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    await this.getRelationData();
    await this.getBaseData();
    await this.getUserInfo();
    await this.getTemplatesData();
    this.setCustRelation();

    loading.close();

    // this.user.user_name = "UserName";
    let theme = localStorage.getItem('theme');
    if (theme) {
      if (theme == 'yellow') {
        this.theme = 'secpNavStyle secp-content';
      }
      if (theme == 'blue') {
        this.theme = 'secpNavStyle1 secp-content';
      }
      if (theme == 'green') {
        this.theme = 'secpNavStyle2 secp-content';
      }
      if (theme == 'gray') {
        this.theme = 'secpNavStyle3 secp-content';
      }
    }

    ///初始化菜单
    _.each(this_.nav, (x) => {
      if (x.children) {
        _.each(x.children, (c) => {
          if (c.name.indexOf('nav.') < 0) {
            this_.$set(c, 'name', this_.$t(`nav.${c.name}`));
          }
        });
      }
      if (x.name.indexOf('nav.') < 0 && x.name != 'CPSP') {
        this_.$set(x, 'name', this_.$t(`nav.${x.name}`));
      }
    });
  },
  computed: {
    // list() {
    //   return this.$route.matched.filter((route) => route.name || route.meta.label);
    // },
    list() {
      let this_ = this;
      let f = this_.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
      let c = _.map(f, function (o) {
        let url_title = 'CPSP';
        // if (apiConfig.env === "development") {
        //   url_title = "测试"
        // }
        let meta = { label: o.name };
        if (o.name != 'CPSP') {
          meta = { label: this_.$t(`nav.${o.name}`) };
        }
        if (o.name == 'CPSP') {
          document.title = url_title + ' - 首页';
        } else {
          document.title = url_title + ' - ' + this_.$t(`nav.${o.name}`);
        }

        return { name: o.name, meta, path: o.path, redirect: o.redirect };
      });
      return c;
    },
  },
  async mounted() {
    //全局错误保存
    window.onerror = (msg, url, line, col, error) => {
      console.log(msg, url, line, col, error)
      const log_data = {
        category: commonController.LOG_CATEGORY_EMUS.ERROR,
        content_type: 'GLOBAL_ERROR',
        info: error.toString(),
        data: JSON.stringify({ msg: msg, url: url, line: line, col: col, error: error }),
        idx: ''
      }
      commonController.methods.saveLogClient(log_data)
    }
    window.addEventListener('unhandledrejection', (event) => {
      const info = { msg: event.reason.message, line: event.reason.lineNumber, col: event.reason.columnNumber, url: event.reason.fileName }
      const log_data = {
        category: commonController.LOG_CATEGORY_EMUS.ERROR,
        content_type: 'GLOBAL_ERROR',
        info: event.reason.message.toString(),
        data: JSON.stringify(info),
        idx: ''
      }
      commonController.methods.saveLogClient(log_data)
    })
    window.addEventListener('beforeunload', this.handlePageRefresh);
    this.is_production = !this.$store.state.is_production;
    // await this.getRelationData();
    // await this.getBaseData();
    // await this.getUserInfo()
    // this.setCustRelation()
    localStorageMgr.remove(localStorageMgr.data.version);

    setInterval(async () => {
      await this.checkVersion();
      await this.getUserMessageList();
    }, 60000);

    const hide_header = true;
    const hide_footer = false;
    let content_height = 0,
      breadcrumb_height = 0;
    const header = document.getElementById('header');
    const footer = document.getElementById('footer');
    console.log(this.$route.path);
    if (this.$route.path === '/dashboard') {
      footer.style.height = '50px';
    } else {
      footer.style.height = '0px';
    }

    const content = document.querySelector('.secp-content');
    const sidebar = content.querySelector('.sidebar');
    const breadcrumb = document.querySelector('.breadcrumb');
    const container_fluid = document.querySelector('.container-fluid');
    content_height = content.getBoundingClientRect().height;
    breadcrumb_height = breadcrumb.getBoundingClientRect().height;
    const header_height = header.getBoundingClientRect().height;
    const footer_height = footer.getBoundingClientRect().height;
    function updateContentPadding() {
      if (hide_header) {
        sidebar.style.height = '100%';
      }
      // const headerHeight = header.offsetHeight;
      // content.style.paddingTop = header.classList.contains('hidden') ? '0' : `${headerHeight}px`;
      // content.style.marginTop = header.classList.contains('hidden') ? '0' : `${headerHeight}px`;
      content.style.marginTop = hide_header ? 0 : header_height;
      // if(header.classList.contains('hidden')){
      // breadcrumb.style.top='0px'
      // breadcrumb.style.paddingTop='0px'
      content.style.height = hide_header
        ? content_height + header_height - footer_height + 'px'
        : content_height - header_height - footer_height + 'px';
      container_fluid.style.height = hide_header
        ? content_height + header_height - breadcrumb_height + 'px'
        : content_height - footer_height - breadcrumb_height + 'px';
      //       }else{
      //         // breadcrumb.style.top='55px'
      //         content.style.height=(content_height)+'px'
      // container_fluid.style.height=(content_height-breadcrumb_height)+'px'
      //       }
    }

    let headerTimeout, footerTimeout;

    function showHeader() {
      header.classList.remove('hidden');
      updateContentPadding();
      clearTimeout(headerTimeout);
      headerTimeout = setTimeout(() => {
        header.classList.add('hidden');
      }, 2000); // 3秒后隐藏
    }

    function showFooter() {
      footer.classList.remove('hidden');
      updateContentPadding();
      clearTimeout(footerTimeout);
      footerTimeout = setTimeout(() => {
        footer.classList.add('hidden');
      }, 2000); // 3秒后隐藏
    }

    document.addEventListener('mousemove', (event) => {
      if (event.clientY < 10) {
        // 当鼠标靠近顶部
        if (hide_header) {
          showHeader();
        }
      }
      if (window.innerHeight - event.clientY < 10) {
        // 当鼠标靠近底部
        if (hide_footer) {
          showFooter();
        }
      }
    });

    // 初始计算
    updateContentPadding();

    if (hide_header) {
      showHeader();
    }
    if (hide_footer) {
      showFooter();
    }

    EventBus.$on('enter_dashboard', () => {
      footer.style.height = '50px';
    });

    EventBus.$on('leave_dashboard', () => {
      footer.style.height = '0px';
    });

    await this.checkVersion();
    await this.getUserMessageList();
    await this.getUserSetting();
  },
  methods: {
    handlePageRefresh() {
      const log_data = {
        category: commonController.LOG_CATEGORY_EMUS.REFRESH,
        content_type: 'APPLICATION_REFRESH',
        info: 'Application is Refreshed',
        data: '',
        idx: ''
      }
      commonController.methods.saveLogClient(log_data)
    },
    //获取用户配置
    async getUserSetting() {
      let result = await api.query_async({
        url: apiPath.user.get_user_setting,
        parameters: { key: 'table_col_setting' },
        method: 'get',
      });
      console.log(result);
      if (result && result[0].result && result[0].result.data) {
        if (result[0].result.data.Result[0].data) {
          let _data = JSON.parse(result[0].result.data.Result[0].data);
          localStorage.setItem('selectColHeader', _data.selectColHeader);
          localStorage.setItem('allhearder', _data.allhearder);
        }
      } else {
        return null;
      }
    },
    ///check_version
    async checkVersion() {
      let result = await SystemSettingController.methods.GetData({
        code: { '=': 'h5_version' },
      });
      if (result[0].length >= 0 && result[0][0]) {
        let vStr = result[0][0].setting_value;
        let v = null;
        if (this.ls.get(localStorageMgr.data.version) != '')
          v = JSON.parse(this.ls.get(localStorageMgr.data.version));
        if (v && v != vStr) {
          this.$message({
            showClose: true,
            message: '当前版本不是最新版，请重新登录！',
            type: 'warning',
            duration: 0
          });
        } else {
          this.plantSetting.version = vStr;
          this.ls.set(localStorageMgr.data.version, JSON.stringify(vStr));
        }
      }
    },
    async getUserMessageList() {
      if (this.$store.state.biz_data && this.$store.state.biz_data.userInfo) {
        let _user = _.cloneDeep(this.$store.state.biz_data.userInfo);
        let rt = await UserManageController.methods.getUserMessageList(
          _user.user_id
        );
        let dt = [];
        if (rt && rt[0]) {
          for (var i in rt[0]) {
            let _num = parseInt(i) + 1;
            let t = rt[0][i];
            let _index =
              _.findIndex(dt, (m) => {
                return (
                  m.DocumentType == t.DocumentType &&
                  m.ApproveType == t.ApproveType &&
                  m.ItemId == t.ItemId
                );
              }) < 0;
            if (_index)
              dt.push({
                num: _num,
                context: `${t.DocumentCreateBy}提交的“${t.description}”需要您处理！`,
                DocumentType: t.DocumentType,
                ApproveType: t.ApproveType,
                ApproveStatus: t.ApproveStatus,
                ItemData: t.ItemData,
                ItemId: t.ItemId,
                SpParams: t.SpParams,
                create_at:
                  t.create_at != null
                    ? this.$date.format(
                      new Date(t.create_at),
                      'yyyy-MM-dd HH:mm'
                    )
                    : '',
              });
          }
          this.messageData = dt;
          this.messageDataCount = dt.length;
        }
      }
    },
    ///get userInfo
    async getUserInfo() {
      let rt = await UserManageController.methods.getUserLanguage();
      let _result = await api.query_async({
        url: apiPath.user.profile,
        parameters: null,
        method: 'get',
      });

      if (_result && _result[0].result) {
        this.$store.commit('init_biz_data', {
          content_path: 'biz_data',
          content_type: 'userInfo',
          data: { user_roles_privileges: _result[0].result.data.Result },
        });

        ///更新登录用户
        let local_username = '';
        local_username = _result[0].result.data.Result.username;
        let is_Include_All = '';
        is_Include_All = _result[0].result.data.Result.is_Include_All;
        let _user_id = jwtDecode(this.ls.get('access_token')).data.id;
        this.$store.commit('init_biz_data', {
          content_path: 'biz_data',
          content_type: 'userInfo',
          data: {
            user_id: _user_id,
            local_username: local_username,
            is_Include_All: is_Include_All,
            allUsers: rt ? rt[0] : [],
          },
        });
        this.$global.global_data.local_username = local_username;
        this.user.user_name = local_username;
        this.user.is_Include_All = is_Include_All;
        localStorageMgr.set(
          localStorageMgr.data.last_login_account,
          local_username
        );
      }
    },
    //切换主题
    changeTheme(val) {
      switch (val) {
        case 'yellow':
          localStorage.setItem('theme', 'yellow');
          this.theme = 'secpNavStyle';
          break;
        case 'blue':
          localStorage.setItem('theme', 'blue');
          this.theme = 'secpNavStyle1';
          break;
        case 'green':
          localStorage.setItem('theme', 'green');
          this.theme = 'secpNavStyle2';
          break;
        case 'gray':
          localStorage.setItem('theme', 'gray');
          this.theme = 'secpNavStyle3';
          break;
        default:
          break;
      }
    },
    ///获取并设置baseData
    async getBaseData() {
      let _base_result = await api.query_async({
        url: apiPath.plant.base_data,
        parameters: null,
        method: 'get',
      });

      this.$store.commit('init_biz_data', {
        content_path: 'biz_data',
        content_type: 'baseData',
        data: _base_result[0].result.data.Result,
      });
    },
    ///获取并设置邮件模板数据
    async getTemplatesData() {
      let _result =
        await NotifyTemplateManageController.methods.GetNotifyTemplates();

      let _list = [];
      if (_result && _result.length > 0) {
        _list = _result[0];
      }
      this.$store.commit('init_biz_data', {
        content_path: 'biz_data',
        content_type: 'templateData',
        data: { templates: _list },
      });
    },
    setCustRelation() {
      let _cust = this.$store.state.biz_data.baseData.Customer;
      if (_cust && _cust.length > 0) {
        let _myCustData = [];
        if (this.user.is_Include_All) {
          _.each(_cust, (t) => {
            _myCustData.push(t);
          });
        } else {
          let _my_custs = this.$store.state.biz_data.Relation.relation;
          _.each(_my_custs, (t) => {
            let _m = _.find(_cust, { AccountNum: t.AccountNum });
            if (_m) {
              _myCustData.push(_m);
            }
          });
        }

        this.$store.commit('init_biz_data', {
          content_path: 'biz_data',
          content_type: 'userInfo',
          data: {
            user_custs: _.orderBy(_myCustData, ['modifiedDateTime'], ['desc']),
          },
        });
      }
    },
    async getRelationData() {
      let _this = this;
      let _user_id = jwtDecode(this.ls.get('access_token')).data.id;
      let _id = _user_id;
      let _params = {
        user_id: { '=': _id },
      };
      let relation = await CustTableBindUserController.methods.getRelation(
        _params
      );
      if (relation) {
        _this.$store.commit('init_biz_data', {
          content_path: 'biz_data',
          content_type: 'Relation',
          data: { relation: relation[0] },
        });
      }
    },
    //打开右侧菜单个人信息
    rightMenuToUserInfo() {
      this.$refs.sidebarRef.$el.click();
      this.$refs.rightMenu.tabIndex = 3;
    },
    async toMessage() {
      await this.getUserMessageList();
      this.dialogTableVisible = true;
    },
    handleClick(row) {
      let _k = '',
        itemData = null;
      let url = '';
      if (row.ItemData) itemData = JSON.parse(row.ItemData)[0];
      switch (row.DocumentType) {
        case 'SalesOrder':
          url = '/sd/SalesOrder';
          _k = itemData ? itemData.SalesId : '';
          break;
        case 'SalesOrderDispatch':
          url = '/sd/saleOrderDispatch';
          _k = itemData ? itemData.SalesId : '';
          break;
        case 'CustomerCredit':
          url = '/fi/CustomerCredit';
          break;
        case 'CustomerTempCredit':
          url = '/fi/CustomerCredit';
          break;
        case 'VendInitialQuote':
          url = '/sd/VendInitialQuote';
          break;
        case 'VendQuote':
          url = '/sd/VendPurchaseQuoteOut';
          break;
        case 'VendInternalQuote':
          url = '/sd/VendPurchaseQuoteOut';
          break;
        case 'SalesQuoteApplication':
          url = '/sq/QuotationTask';
          _k = itemData ? itemData.QuotationTaskNum : '';
          break;
        case 'SalesQuoteDistribution':
          url = '/sq/QTHDistribution';
          _k = itemData ? itemData.QuotationTaskNum : '';
          break;
        case 'SalesQuoteOrder':
          url = '/sq/QuotationOrder';
          _k = itemData ? itemData.QuotationTaskNum : '';
          break;
        case 'SalesQuoteDistributionPre':
          url = '/sq/QTHDistribution';
          break;
        case 'SalesQuoteDistributionPreApply':
          url = '/sq/QTHDistribution';
          break;
        case 'SalesQuoteWeightCost':
          url = '/sq/QuotationOrderConfirm';
          _k = itemData ? itemData.QuotationTaskNum : '';
          break;
      }
      if (
        window.location.href.indexOf(url) < 0 ||
        window.location.href.indexOf(_k) < 0
      )
        this.$router.push({ path: url, query: { k: _k } });
      this.dialogTableVisible = false;
    },
  },
};
</script>
<style>
.no-shown-RetailVariantId {
  display: none !important;
}

.notify550 {
  width: 550px;
}

.notify650 {
  width: 650px;
}

.notify750 {
  width: 750px;
}

.hideId {
  display: none !important;
}

.tdCLass {
  width: 100px;
}

.zZindex {
  z-index: 9999 !important;
}
</style>
<style scoped>
@media (min-width: 992px) {

  html:not([dir='rtl']) .aside-menu-show.aside-menu-fixed .main,
  html:not([dir='rtl']) .aside-menu-show.aside-menu-fixed .app-footer,
  html:not([dir='rtl']) .aside-menu-lg-show.aside-menu-fixed .main,
  .app-footer {
    margin-right: 0px;
  }

  .container {
    max-width: 100%;
    width: 100%;
  }

  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    margin: 0;
    padding: 0;
  }
}

.breadcrumb {
  background-color: #fff;
  height: 46px;
  border-radius: 0;
}

.main {
  margin-left: 0;
}

.main .container-fluid {
  height: 100%;
  padding: 4px;
  /* margin-top: -18px; */
  overflow: hidden;
  background-color: #fff !important;
}

.main .el-tabs__header {
  margin: 0 !important;
}

.breadcrumb-fixed .main {
  padding-top: 0px;
}

.breadcrumb {
  margin-bottom: 0;
}

.breadcrumb-fixed .breadcrumb {
  display: flex;
  position: relative;
  top: 0;
  left: 0;
}

html:not([dir='rtl']) .sidebar-lg-show.breadcrumb-fixed .breadcrumb,
html:not([dir='rtl']) .sidebar-show.breadcrumb-fixed .breadcrumb {
  left: 0;
}

/* 初始样式 */
#header {
  position: fixed;
  height: 55px;
  top: 0;
  left: 0;
  width: 100%;
  transition: height 0.3s ease-in-out;
  /* 高度变化的过渡效果 */
}

/* 隐藏状态 */
#header.hidden {
  height: 0;
  overflow: hidden;
  /* 防止内容溢出 */
}

/* 初始样式 */
#footer {
  position: fixed;
  height: 50px;
  bottom: 0;
  left: 0;
  width: 100%;
  transition: height 0.3s ease-in-out;
  /* 高度变化的过渡效果 */
}

/* 隐藏状态 */
#footer.hidden {
  height: 0;
  overflow: hidden;
  /* 防止内容溢出 */
}
</style>
